<div
	class="pet-information"
	role="presentation"
>
	<section class="pet-information__content" *ngIf="!showEnhancedContent">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</section>

	<section class="pet-information__content enhanced" *ngIf="showEnhancedContent">
		<ng-container *ngTemplateOutlet="contentEnhanced"></ng-container>
	</section>
</div>

<ng-template #content>
	<section
		*ngIf="quoteRetrievalError"
		class="pet-information__retrieve-error"
	>
		<button
			class="o-modal-dismiss"
			(click)="quoteRetrievalError = !quoteRetrievalError"
		>
			<epi-icon
				use="close"
				size="24"
			></epi-icon>
		</button>
		<p class="pet-information__retrieve-error-heading">
			<epi-icon
				use="error"
				color="warn"
				[size]="24"
				class="pet-information__retrieve-error-heading-icon"
			></epi-icon>
			Oh no! We couldn't retrieve your quote.
		</p>
		<section class="pet-information__retrieve-error-content">
			<p class="pet-information__retrieve-error-message">
				No worries, it's super fast to get a new one. Literally seconds.
			</p>
			<p class="pet-information__retrieve-error-message">
				Or call us at {{ brandPhoneNumber$ | async }} and a Pet Insurance
				Advisor can help retrieve your quote.
			</p>
		</section>
	</section>
	<qe-content-section>
		<epi-heading
			level="1"
			color="primary"
			class="pet-information__heading"
		>
			Your Customized Quote in Seconds
		</epi-heading>
		<epi-hint class="pet-information__hint">
			Tell us about your pet below to get a personalized quote in under 30 seconds.
		</epi-hint>
		<ng-container *ngTemplateOutlet="petInformationFormTemplate"></ng-container>
	</qe-content-section>
	<qe-content-section *ngIf="showEmployerForm">
		<epi-heading
			level="2"
			appears-as="1"
			color="primary"
		>
			Employer Information
		</epi-heading>
		<form
			[formGroup]="employerForm"
			class="pet-information__employer"
		>
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerName">
						<span slot="label">Employer Name</span>
						<input
							#employerNameEl
							formControlName="name"
							placeholder="Enter Employer Name"
							slot="epiInput"
							type="search"
							autocomplete="new-password"
							data-quat="input_employerName"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerName?.errors?.required &&
							(employerName?.touched || formInvalid)
						">
						Please enter the name of your employer.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerStreetAddress">
						<span slot="label">Street Address</span>
						<input
							formControlName="address"
							slot="epiInput"
							type="text"
							data-quat="input_employerAddress"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerAddress?.errors?.required &&
							(employerAddress?.touched || formInvalid)
						">
						Please enter your employer's address.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerCity">
						<span slot="label">City</span>
						<input
							formControlName="city"
							slot="epiInput"
							type="text"
							data-quat="input_employerCity"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerCity?.errors?.required &&
							(employerCity?.touched || formInvalid)
						">
						Please enter your employer's city.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-3 u-margin-top-medium"
					role="presentation"
				>
					<epi-select
						qeCustomInput
						formControlName="state"
						data-quat="input_employerState"
					>
						<span slot="label">State</span>
						<epi-option
							*ngFor="let state of stateList; let i = index"
							[value]="state.abbreviation"
							id="employerStateOption{{ i }}"
							slot="option"
							attr.data-quat="input_employerState{{ i }}"
						>
							{{ state.abbreviation }} - {{ state.name }}
						</epi-option>
					</epi-select>
					<epi-validation-error *ngIf="
							employerState?.errors?.required &&
							(employerState?.touched || formInvalid)
						">
						Please select your employer's state.
					</epi-validation-error>
				</div>
				<div
					class="u-row__column m--tablet-3 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerZipCode">
						<span slot="label">Zip Code</span>
						<input
							formControlName="zipCode"
							slot="epiInput"
							type="text"
							data-quat="input_employerZipCode"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerZipCode?.errors?.required &&
							(employerZipCode?.touched || formInvalid)
						">
						Please enter your employer's zip code.
					</epi-validation-error>
				</div>
			</div>
			<div
				role="presentation"
				class="u-row u-margin-top-small"
			>
				<div
					role="presentation"
					class="u-row__column u-margin-top"
				>
					<ng-container *ngTemplateOutlet="submitButton"></ng-container>
				</div>
			</div>
		</form>
	</qe-content-section>
	<qe-content-section *ngIf="showAgentForm">
		<epi-heading
			level="2"
			appears-as="1"
			color="primary"
		>
			Agent Information
		</epi-heading>
		<form [formGroup]="agentForm">
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-4 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="partnerSenderId">
						<span slot="label">
							Agent ID
							<epi-tooltip>
								Agent ID is required. Your Agent ID can be found on your
								Embrace Pet Insurance Contact sheet.
							</epi-tooltip>
						</span>
						<input
							formControlName="partnerSenderId"
							slot="epiInput"
							type="text"
							data-quat="input_partnerSenderId"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							partnerSenderId?.errors?.required &&
							(partnerSenderId?.touched || formInvalid)
						">
						Please enter your agent ID.
					</epi-validation-error>
				</div>
			</div>
			<div
				role="presentation"
				class="u-row u-margin-top-medium"
			>
				<div
					role="presentation"
					class="u-row__column u-margin-top"
				>
					<ng-container *ngTemplateOutlet="submitButton"></ng-container>
				</div>
			</div>
		</form>
	</qe-content-section>
</ng-template>

<ng-template #contentEnhanced>
	<section
		*ngIf="quoteRetrievalError"
		class="pet-information__retrieve-error"
	>
		<button
			class="o-modal-dismiss"
			(click)="quoteRetrievalError = !quoteRetrievalError"
		>
			<epi-icon
				use="close"
				size="24"
			></epi-icon>
		</button>
		<p class="pet-information__retrieve-error-heading">
			<epi-icon
				use="error"
				color="warn"
				[size]="24"
				class="pet-information__retrieve-error-heading-icon"
			></epi-icon>
			Oh no! We couldn't retrieve your quote.
		</p>
		<section class="pet-information__retrieve-error-content">
			<p class="pet-information__retrieve-error-message">
				No worries, it's super fast to get a new one. Literally seconds.
			</p>
			<p class="pet-information__retrieve-error-message">
				Or call us at {{ brandPhoneNumber$ | async }} and a Pet Insurance
				Advisor can help retrieve your quote.
			</p>
		</section>
	</section>

	<section class="enhanced-content__container">
		<div class="enhanced-content__item enhanced-content__item--info">
			<div class="enhanced-content__copy-block">
				<h3 class="enhanced-content__sub-heading">20 Years of Pet Insurance Expertise</h3>
				<h1 class="enhanced-content__heading">Worry-Free Care for Your Pet</h1>
				<p class="enhanced-content__copy">Worried about high vet costs? You’re not alone. <span class="screen-desktop">An accident or illness can happen when you least expect it.</span> 1 in 3 pets need emergency vet care every year.<sup>1</sup> With Embrace, you don’t have to choose between your pet and your savings.</p>
				<ul class="enhanced-content__bullets">
					<li><qe-duo-check-icon class="wellness__bullet-item-check" [color1]="checkmarkBackgroundColor" [color2]="checkmarkColor"></qe-duo-check-icon><label><strong>30-day</strong> money back guarantee<sup>2</sup></label></li>
					<li><qe-duo-check-icon class="wellness__bullet-item-check" [color1]="checkmarkBackgroundColor" [color2]="checkmarkColor"></qe-duo-check-icon><label><strong>$830 million</strong> in claims paid out</label></li>
					<li><qe-duo-check-icon class="wellness__bullet-item-check" [color1]="checkmarkBackgroundColor" [color2]="checkmarkColor"></qe-duo-check-icon><label><strong>24/7 PawSupport</strong> pet helpline</label></li>
				</ul>
			</div>
			<img
				[src]="getCdnAsset('elements/quote-form/assets/CatDogCuddle.webp')"
				class="enhanced-content__image screen-desktop"
			>
			<div class="enhanced-content__ratings screen-desktop">
				<img [src]="getCdnAsset('elements/quote-form/assets/Ratings_1.svg')"/>
				<div class="divider"></div>
				<img [src]="getCdnAsset('elements/quote-form/assets/Ratings_2.svg')"/>
				<div class="divider"></div>
				<img [src]="getCdnAsset('elements/quote-form/assets/Ratings_3.svg')"/>
			</div>
		</div>
		<qe-content-section
			[bordered]="false"
			[outlined]="false"
			[marginHorizontal]="false"
			[marginBottom]="false"
			[padding]="false"
			class="enhanced-content__item enhanced-content__item--form">
			<div class="enhanced-content__pet-info-form">
				<h3 class="enhanced-content__pet-info-form__sub-heading">Tell us about your pet & get a customized price in seconds!</h3>
				<ng-container *ngTemplateOutlet="petInformationFormTemplate"></ng-container>
			</div>
			<div
				class="u-row enhanced-content__agreement"
				[class.u-margin-top-small]="!showAllstateOptOut"
				role="presentation"
			>
				<div class="u-row__column">
					<epi-hint *ngIf="showAllstateOptOut; else defaultOptOut">
						By clicking the “{{ submitButtonLabel }}” button below, I agree that Embrace Pet Insurance Agency
						may contact me on behalf of Allstate at the contact information provided above with
						marketing communications related to Allstate insurance products and services they offer.
						This contact may be made by using live operators, automatic telephone dialing systems,
						pre-recorded and artificial voice messages, text messages, and/or emails. I understand
						that message and data rates may apply, that my consent is not required as a condition
						of purchase, and that I may revoke my consent at any time.
					</epi-hint>
					<ng-template #defaultOptOut>
						<epi-hint>
							By clicking ‘{{ submitButtonLabel }}’ you consent for us to contact you about Embrace Pet Insurance
							services via email, text and phone calls to the contact information provided using automated technology. Phone
							number is not required to start quote. Your information is collected
							and used in accordance with Embrace’s
							<a
								qeBaseLink
								size="small"
								[href]="privacyPolicyUrl"
								target="_blank"
								class="n--minimal"
							>
								Privacy Policy
							</a> and
							<a
								qeBaseLink
								size="small"
								[href]="smsTermsAndConditionsUrl"
								target="_blank"
								class="n--minimal"
							>
								Texting Terms
							</a>
							. Opt out any time.
						</epi-hint>
					</ng-template>
				</div>
			</div>
			<div class="enhanced-content__ratings screen-mobile">
				<img [src]="getCdnAsset('elements/quote-form/assets/Ratings_4.svg')"/>
			</div>
			<img [src]="getCdnAsset('elements/quote-form/assets/CatDogCuddle.webp')" class="enhanced-content__image screen-mobile">
		</qe-content-section>
	</section>

	<qe-content-section *ngIf="showEmployerForm">
		<epi-heading
			level="2"
			appears-as="1"
			color="primary"
		>
			Employer Information
		</epi-heading>
		<form
			[formGroup]="employerForm"
			class="pet-information__employer"
		>
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerName">
						<span slot="label">Employer Name</span>
						<input
							#employerNameEl
							formControlName="name"
							placeholder="Enter Employer Name"
							slot="epiInput"
							type="search"
							autocomplete="new-password"
							data-quat="input_employerName"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerName?.errors?.required &&
							(employerName?.touched || formInvalid)
						">
						Please enter the name of your employer.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerStreetAddress">
						<span slot="label">Street Address</span>
						<input
							formControlName="address"
							slot="epiInput"
							type="text"
							data-quat="input_employerAddress"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerAddress?.errors?.required &&
							(employerAddress?.touched || formInvalid)
						">
						Please enter your employer's address.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerCity">
						<span slot="label">City</span>
						<input
							formControlName="city"
							slot="epiInput"
							type="text"
							data-quat="input_employerCity"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerCity?.errors?.required &&
							(employerCity?.touched || formInvalid)
						">
						Please enter your employer's city.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-3 u-margin-top-medium"
					role="presentation"
				>
					<epi-select
						qeCustomInput
						formControlName="state"
						data-quat="input_employerState"
					>
						<span slot="label">State</span>
						<epi-option
							*ngFor="let state of stateList; let i = index"
							[value]="state.abbreviation"
							id="employerStateOption{{ i }}"
							slot="option"
							attr.data-quat="input_employerState{{ i }}"
						>
							{{ state.abbreviation }} - {{ state.name }}
						</epi-option>
					</epi-select>
					<epi-validation-error *ngIf="
							employerState?.errors?.required &&
							(employerState?.touched || formInvalid)
						">
						Please select your employer's state.
					</epi-validation-error>
				</div>
				<div
					class="u-row__column m--tablet-3 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerZipCode">
						<span slot="label">Zip Code</span>
						<input
							formControlName="zipCode"
							slot="epiInput"
							type="text"
							data-quat="input_employerZipCode"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerZipCode?.errors?.required &&
							(employerZipCode?.touched || formInvalid)
						">
						Please enter your employer's zip code.
					</epi-validation-error>
				</div>
			</div>
			<div
				role="presentation"
				class="u-row u-margin-top-small"
			>
				<div
					role="presentation"
					class="u-row__column u-margin-top"
				>
					<ng-container *ngTemplateOutlet="submitButton"></ng-container>
				</div>
			</div>
		</form>
	</qe-content-section>
	<qe-content-section *ngIf="showAgentForm">
		<epi-heading
			level="2"
			appears-as="1"
			color="primary"
		>
			Agent Information
		</epi-heading>
		<form [formGroup]="agentForm">
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-4 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="partnerSenderId">
						<span slot="label">
							Agent ID
							<epi-tooltip>
								Agent ID is required. Your Agent ID can be found on your
								Embrace Pet Insurance Contact sheet.
							</epi-tooltip>
						</span>
						<input
							formControlName="partnerSenderId"
							slot="epiInput"
							type="text"
							data-quat="input_partnerSenderId"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							partnerSenderId?.errors?.required &&
							(partnerSenderId?.touched || formInvalid)
						">
						Please enter your agent ID.
					</epi-validation-error>
				</div>
			</div>
			<div
				role="presentation"
				class="u-row u-margin-top-medium"
			>
				<div
					role="presentation"
					class="u-row__column u-margin-top"
				>
					<ng-container *ngTemplateOutlet="submitButton"></ng-container>
				</div>
			</div>
		</form>
	</qe-content-section>
</ng-template>

<ng-template #submitButton>
	<epi-validation-error
		*ngIf="showAgeError"
		class="u-margin-bottom-small"
		gtm-id="error_generic-pet_info-min_age"
	>
		Pets need to be at least 6 weeks of age to enroll.
	</epi-validation-error>
	<epi-validation-error
		*ngIf="formInvalid"
		class="u-margin-bottom-small"
		gtm-id="error_incomplete-pet_info-incomplete_form"
	>
		Please complete all required fields before continuing.
	</epi-validation-error>
	<epi-validation-error
		*ngIf="policyHolderExists"
		class="u-margin-bottom-small error-policy-holder"
		gtm-id="error_api-pet_info-existing_policy_holder"
	>
		<span>Oops, it looks like you're already an existing policy holder! Please visit your customer portal to <a [href]="myEmbraceUrlChangeCoverage" target="_blank">change coverage</a> or <a  [href]="myEmbraceUrlAddAPet" target="_blank">add a pet</a>. For anything else, please call us at 800-383-9088.</span>
	</epi-validation-error>
	<ng-container *ngIf="ruleError">
		<epi-validation-error
			*ngFor="let error of ruleErrorList"
			class="u-margin-bottom-small"
			[attr.gtm-id]="'error_api-pet_info-' + error"
		>
			{{ error }}
		</epi-validation-error>
	</ng-container>
	<section [class.pet-information__start-quote--reversed]="showAllstateOptOut">
		<button
			qeBaseButton
			type="submit"
			(click)="submitForm()"
			data-quat="action_startQuote"
			[class.u-margin-top-small]="showAllstateOptOut"
			[disabled]="submittingForm"
		>
			{{ submitButtonLabel }}
		</button>
		<p class="reassurance-text">No commitment. Just your price.</p>
		<div
			class="u-row"
			[class.u-margin-top-small]="!showAllstateOptOut"
			role="presentation"
			*ngIf="!showEnhancedContent"
		>
			<div class="u-row__column">
				<epi-hint *ngIf="showAllstateOptOut; else defaultOptOut">
					By clicking the “{{ submitButtonLabel }}” button below, I agree that Embrace Pet Insurance Agency
					may contact me on behalf of Allstate at the contact information provided above with
					marketing communications related to Allstate insurance products and services they offer.
					This contact may be made by using live operators, automatic telephone dialing systems,
					pre-recorded and artificial voice messages, text messages, and/or emails. I understand
					that message and data rates may apply, that my consent is not required as a condition
					of purchase, and that I may revoke my consent at any time.
				</epi-hint>
				<ng-template #defaultOptOut>
					<epi-hint>
						By clicking ‘{{ submitButtonLabel }}’ you consent for us to contact you about
						Embrace Pet Insurance services via email and phone calls to
						the contact information provided using automated technology. Phone
						number is not required to start quote. Your information is collected
						and used in accordance with Embrace’s
						<a
							qeBaseLink
							size="small"
							[href]="privacyPolicyUrl"
							target="_blank"
							class="n--minimal"
						>
							Privacy Policy
						</a>
						. Opt out any time.
					</epi-hint>
				</ng-template>
			</div>
		</div>
	</section>
</ng-template>

<ng-template #petInformationFormTemplate>
	<form
	[formGroup]="petInformationForm"
	class="pet-information__form"
>
	<section class="add-pet-form" *ngFor="let pet of petsArrayControl.controls; let i = index" formArrayName="pets">
		<a role="button" class="remove-pet-button" (click)="handleRemovePet(i)" *ngIf="petsArrayControl.length !== 1">
			<qe-trash-icon class="remove-pet-button__icon" variableName="brandPrimary"></qe-trash-icon>
			<span>Remove Pet</span>
		</a>
		<div
			class=""
			role="presentation"
			[formGroupName]="i"
		>
			<div
				class="u-row inline-form-row"
				role="presentation"
				*ngIf="showEnhancedContent"
			>
				<div class="c-form-input u-row__column">
					<epi-input [inputId]="'petName' + i">
						<div class="form_input" slot="epiInput">
							<input
								id="{{'petName' + i}}"
								class="form_input-input inside"
								formControlName="name"
								slot="epiInput"
								name="{{'petName' + i}}"
								type="text"
								maxlength="100"
								(focus)="onFocus('petName'+ i)"
								(blur)="onBlur('petName')"
								data-quat="input_petName"
							/>
							<label
								class="form_input-label"
								[class.focused]="petNameFocused(i) || petsArrayControl.controls[i].get('name')?.value"
								for="{{'petName' + i}}"
							>
								Pet's Name
							</label>
						</div>
						<epi-validation-error
							*ngIf="petsArrayControl.controls[i].get('name')?.hasError('required') && petsArrayControl.controls[i].get('name')?.touched"
							data-quat="alert_petNameValidation"
							gtm-id="error_form-field_pet-name_required"
						>Please enter your pet's name.</epi-validation-error>
						<epi-validation-error
							*ngIf="petsArrayControl.controls[i].get('name')?.hasError('pattern') && petsArrayControl.controls[i].get('name')?.touched"
							gtm-id="error_form-field_pet-name_invalid"
						>
							Your pet's name must start with a letter or number and may not
							contain special characters.
						</epi-validation-error>
						<epi-validation-error
							*ngIf="petsArrayControl.controls[i].get('name')?.hasError('maxLength') &&
								(petsArrayControl.controls[i].get('name')?.touched)"
								gtm-id="error_form-field_pet-name_max-length"
							>
							Your pet's name may not be longer than 100 characters.
						</epi-validation-error>
					</epi-input>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div
					class="c-form-input u-row__column"
					*ngIf="!showEnhancedContent"
				>
					<epi-input [inputId]="'petName' + i">
						<div class="form_input" slot="epiInput">
							<input
								id="{{'petName' + i}}"
								class="form_input-input inside"
								formControlName="name"
								slot="epiInput"
								name="{{'petName' + i}}"
								type="text"
								maxlength="100"
								(focus)="onFocus('petName'+ i)"
								(blur)="onBlur('petName')"
								data-quat="input_petName"
							/>
							<label
								class="form_input-label"
								[class.focused]="petNameFocused(i) || petsArrayControl.controls[i].get('name')?.value"
								for="{{'petName' + i}}"
							>
								Pet's Name
							</label>
						</div>
						<epi-validation-error
							*ngIf="petsArrayControl.controls[i].get('name')?.hasError('required') && petsArrayControl.controls[i].get('name')?.touched"
							data-quat="alert_petNameValidation"
							gtm-id="error_form-field_pet-name_required"
						>Please enter your pet's name.</epi-validation-error>
						<epi-validation-error
							*ngIf="petsArrayControl.controls[i].get('name')?.hasError('pattern') && petsArrayControl.controls[i].get('name')?.touched"
							gtm-id="error_form-field_pet-name_invalid"
						>
							Your pet's name must start with a letter or number and may not
							contain special characters.
						</epi-validation-error>
						<epi-validation-error
							*ngIf="petsArrayControl.controls[i].get('name')?.hasError('maxLength') &&
								(petsArrayControl.controls[i].get('name')?.touched)"
								gtm-id="error_form-field_pet-name_max-length"
							>
							Your pet's name may not be longer than 100 characters.
						</epi-validation-error>
					</epi-input>
				</div>
				<div class="c-form-input u-row__column toggle-wrapper toggle-wrapper__species">
					<epi-option-toggle
						qeCustomInput
						[formControlName]="'species'"
						id="{{'pet-informaton-species' + i}}"
						size="medium"
						layout="dense"
						data-quat="input_pet-species"
						(epiValueChanged)="onRadioChange"
					>
						<epi-toggle-choice
							id="{{'speciesMale' + i}}"
							value="dog"
							popular="false"
							slot="option"
							[selected]="pet.value.species === 'dog'"
							data-quat="input_speciesDog"
							(epi-toggle_selectionChange)="onRadioChange('pet_species', 'dog', i)"
						>
						<div class="option-toggle">
							<qe-dog-icon *ngIf="pet.value.species === 'dog'" variableName="white"></qe-dog-icon>
							<qe-dog-icon *ngIf="pet.value.species !== 'dog'" variableName="brandSecondary"></qe-dog-icon>
							<div>Dog</div>
						</div>
						</epi-toggle-choice>
						<epi-toggle-choice
							id="{{'speciesFemale' + i}}"
							value="cat"
							popular="false"
							slot="option"
							data-quat="input_speciesCat"
							[selected]="pet.value.species === 'cat'"
							(epi-toggle_selectionChange)="onRadioChange('pet_species', 'cat', i)"
						>
						<div class="option-toggle">
							<qe-cat-icon *ngIf="pet.value.species === 'cat'" variableName="white"></qe-cat-icon>
							<qe-cat-icon *ngIf="pet.value.species !== 'cat'" variableName="brandSecondary"></qe-cat-icon>
							<div>Cat</div>
						</div>
						</epi-toggle-choice>
					</epi-option-toggle>
					<epi-validation-error
						*ngIf="petsArrayControl.controls[i].get('species')?.invalid && petsArrayControl.controls[i].get('species')?.touched"
						gtm-id="error_form-field_pet-species_required"
					>
						Please select your pet's species.
					</epi-validation-error>
				</div>
				<div class="c-form-input u-row__column toggle-wrapper">
					<epi-option-toggle
						qeCustomInput
						formControlName="sex"
						size="medium"
						layout="dense"
						data-quat="input_pet-sex"
					>
						<epi-toggle-choice
							id="{{'sexMale' + i}}"
							value="male"
							popular="false"
							slot="option"
							[selected]="pet.value.sex === 'male'"
							data-quat="input_genderMale"
							(epi-toggle_selectionChange)="onRadioChange('pet_sex', 'male')"
						>
							<div class="option-toggle">
								<qe-male-icon *ngIf="pet.value.sex === 'male'" variableName="white"></qe-male-icon>
								<qe-male-icon *ngIf="pet.value.sex !== 'male'" variableName="brandSecondary"></qe-male-icon>
								<div>Male</div>
							</div>
						</epi-toggle-choice>
						<epi-toggle-choice
							id="{{'sexFemale' + i}}"
							value="female"
							popular="false"
							slot="option"
							data-quat="input_genderFemale"
							[selected]="pet.value.sex === 'female'"
							(epi-toggle_selectionChange)="onRadioChange('pet_sex', 'female')"
						>
							<div class="option-toggle">
								<qe-female-icon *ngIf="pet.value.sex === 'female'" variableName="white"></qe-female-icon>
								<qe-female-icon *ngIf="pet.value.sex !== 'female'" variableName="brandSecondary"></qe-female-icon>
								<div>Female</div>
							</div>
						</epi-toggle-choice>
					</epi-option-toggle>
					<epi-validation-error
						*ngIf="petsArrayControl.controls[i].get('sex')?.invalid && (formInvalid || petsArrayControl.controls[i].get('sex')?.touched)"
						gtm-id="error_form-field_pet-sex_required"
					>
						Please select your pet's sex.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row inline-form-row"
				role="presentation"
			>
				<div class="u-row__column m--tablet-6 toggle-wrapper">
					<qe-autosearch
						#breedDropdownEl
						qeCustomInput
						[disabled]="!pet.value.species"
						[formGroup]="getPetFormGroup(i)"
						inputId="{{'breed' + i}}"
						data-quat="input_breed"
						[options]="pet.value.breedList"
					></qe-autosearch>
					<epi-validation-error
						*ngIf="petsArrayControl.controls[i].get('breed')?.invalid && petsArrayControl.controls[i].get('breed')?.touched"
						class="breed-error"
						gtm-id="error_form-field_pet-breed_required"
					>
						Please select your pet's breed.
					</epi-validation-error>
				</div>

				<div class="u-row__column m--tablet-6">
					<qe-age-select-menu
						#ageInputEl
						qeCustomInput
						data-quat="input_age"
						input-id="{{'age' + i}}"
						[identifier]="'age'"
						[formGroup]="getPetFormGroup(i)"
						[labelText]="'Your Pet\'s Age'"
						[options]="ageListMock | keyvalue"
					>
					</qe-age-select-menu>
					<epi-validation-error
						*ngIf="petsArrayControl.controls[i].get('age')?.invalid && petsArrayControl.controls[i].get('age')?.touched"
						gtm-id="error_form-field_pet-age_required"
					>
						Please select your pet's age.
					</epi-validation-error>
				</div>
			</div>
			<div
				*ngIf="serviceDogEnabled && pet.value.species === 'dog'"
				class="u-row inline-form-row"
				role="presentation"
			>
				<div class="c-form-input u-row__column service-dog-col">
					<epi-label>Is this dog a service dog?</epi-label>
					<epi-option-toggle
						qeCustomInput
						formControlName="serviceDog"
						size="medium"
						layout="dense"
						data-quat="input_serviceDog"
						id="{{'serviceDog' + i}}"
					>
						<epi-toggle-choice
							id="{{'serviceDogYes' + i}}"
							value="yes"
							popular="false"
							slot="option"
							data-quat="input_serviceDogYes"
							[selected]="pet.value.serviceDog === 'yes'"
							(epi-toggle_selectionChange)="onRadioChange('service_dog', 'yes')"
						>
							Yes
						</epi-toggle-choice>
						<epi-toggle-choice
							id="{{'serviceDogNo' + i}}"
							value="no"
							popular="false"
							slot="option"
							data-quat="input_serviceDogNo"
							[selected]="pet.value.serviceDog === 'no'"
							(epi-toggle_selectionChange)="onRadioChange('service_dog', 'no')"
						>
							No
						</epi-toggle-choice>
					</epi-option-toggle>
					<epi-validation-error
						*ngIf="petsArrayControl.controls[i].get('serviceDog')?.invalid && petsArrayControl.controls[i].get('serviceDog')?.touched"
						gtm-id="error_form-field_pet-service-dog_required"
					>
						Please specify if your dog is a service animal.
					</epi-validation-error>
					<div >
				</div>
			</div>
			<div class="service-dog-disclaimer u-row__column m--tablet-6 " *ngIf="pet.value.serviceDog === 'yes'">
				<img src="../../../assets/icons/exclamation-circle.png" alt="Service Dog" />
				<p>We are able to offer a 5% discount for service dogs that are trained to mitigate the symptoms or effects of their owners' disability.
					Currently, we cannot provide a discount for emotional support animals or therapy dogs. May not apply in all states.
				</p>
			</div>
			</div>
		</div>
	</section>

	<section (click)="handleAddPet()" class="add-pet-button" role="button">
		<epi-button
			button-type="minimal"
			color="secondary"
			data-quat="action_petInfoAddPet"
		>
		<div class="add-pet-button__content">
			<qe-plus-icon variableName="brandPrimary" class="add-pet-button__icon"></qe-plus-icon>
			<span class="add-pet-button__label">Add Another Pet</span>
			<div class="add-pet-button__chip">Save 10%</div>
		</div>
		</epi-button>
	</section>
	<div
		class="u-row inline-form-row"
		role="presentation"
	>
		<div class="c-form-input u-row__column m--tablet-6 u-margin-bottom-small">
			<epi-input
				input-id="zipCode"
				[invalid]="zipCode?.invalid && zipCode?.dirty"
				#zipCodeEl
			>
				<div class="form_input">
					<input
						id="zipCode"
						class="form_input-input inside"
						formControlName="zipCode"
						slot="epiInput"
						type="text"
						name="zipCode"
						inputmode="numeric"
						minlength="5"
						maxlength="5"
						(focus)="onFocus('zipCode')"
						(blur)="onBlur('zipCode')"
						data-quat="input_zipCode"
					/>
					<label
						class="form_input-label"
						[class.focused]="focusedInput === 'zipCode' || zipCode?.value"
						for="zipCode"
					>
						Zip Code
					</label>
				</div>
			</epi-input>
			<epi-hint>*Where you and your pet reside</epi-hint>
			<epi-validation-error
					*ngIf="
						zipCode?.errors?.required && (zipCode?.touched || formInvalid)
					"
					data-quat="alert_zipCodeValidation"
					gtm-id="error_form-field_zip-code_required"
				>
					Please enter your zip code of residence.
			</epi-validation-error>
			<epi-validation-error *ngIf="
					zipCode?.errors?.pattern && (zipCode?.touched || formInvalid)
				"
				gtm-id="error_form-field_zip-code_invalid"
				>
				Zip code may only contain digits.
			</epi-validation-error>
			<epi-validation-error
				*ngIf="
					(zipCode?.errors?.minlength || zipCode?.errors?.maxlength) &&
					(zipCode?.touched || formInvalid)
				"
				gtm-id="error_form-field_zip-code_min-length"
			>
				Zip code must be 5 digits long.
			</epi-validation-error>
		</div>


		<div class="c-form-input u-row__column m--tablet-6">
			<epi-input
				input-id="emailAddress"
				[invalid]="emailAddress?.invalid && emailAddress?.dirty"
				#emailAddressEl
			>
				<div class="form_input">
					<input
						id="emailAddress"
						class="form_input-input inside"
						formControlName="emailAddress"
						type="text"
						name="emailAddress"
						inputmode="email"
						slot="epiInput"
						(focus)="onFocus('emailAddress')"
						(blur)="onBlur('emailAddress')"
						data-quat="input_emailAddress"
					/>
					<label
						class="form_input-label"
						[class.focused]="focusedInput === 'emailAddress' || emailAddress?.value"
						for="emailAddress"
					>
						Email Address
					</label>
				</div>
				<epi-validation-error
					*ngIf="
						emailAddress?.errors?.required &&
						(emailAddress?.touched || formInvalid)
					"
					data-quat="alert_emailAddressValidation"
					gtm-id="error_form-field_email_required"
				>
					Please enter your email address.
				</epi-validation-error>
				<epi-validation-error
					*ngIf="
						emailAddress?.errors?.email &&
						(emailAddress?.touched || formInvalid)
					"
					data-quat="alert_emailAddressValidation"
					gtm-id="error_form-field_email_invalid"
				>
					Please enter a valid email address.
				</epi-validation-error>
			</epi-input>
		</div>
	</div>
	<div
		class="u-row inline-form-row-last"
		role="presentation"
	>
		<div class="u-row__column m--tablet-6">
			<epi-input input-id="phoneNumber">
				<div class="form_input">
					<input
						id="phoneNumber"
						class="form_input-input inside"
						qeInputMask="phone"
						formControlName="phoneNumber"
						type="text"
						inputmode="tel"
						slot="epiInput"
						data-quat="input_phoneNumber"
						(focus)="onFocus('phoneNumber')"
						(blur)="checkPhoneNumber()"
					/>
					<label
						class="form_input-label"
						[class.focused]="focusedInput === 'phoneNumber' || phoneNumber?.value"
						for="phoneNumber"
					>
						Phone Number (optional)
					</label>
				</div>
			</epi-input>
			<epi-validation-error
				*ngIf="
					phoneNumber?.errors?.minlength &&
					phoneNumber?.dirty &&
					phoneNumber?.value?.length
				"
				gtm-id="error_form-field_phone-number_min-length"
			>
				Your phone number must be 10 digits long.
			</epi-validation-error>
		</div>
		<!-- <div class="u-row__column m--tablet-6 sms-checkbox-container" *ngIf="!isModernLinkBrand()">
			<epi-checkbox
				qeEpiControl
				formControlName="optInTextMessage"
				input-id="optInTextMessage"
				input-name="optInTextMessage"
				data-quat="input_optInTextMessage"
				#optInTextMessageCheckbox
				(epiCheckChanged)="handleOptInTextMessageCheckbox(optInTextMessageCheckbox)">
				Sign up for SMS notifications
			</epi-checkbox>
		</div> -->
	</div>
	<div class="u-row" role="presentation" *ngIf="optInTextMessage?.value && phoneNumber?.value">
		<div class="u-row__column">
			<epi-hint class ="sms-opt-in-disclaimer">
				By entering my mobile number and checking this box I agree to Opt in to receive
				important messages from Embrace Pet Insurance regarding my pet insurance quote,
				helpful tips, and general information about our products and services. Msg frq
				varies Text HELP to 98632 for help, Text STOP to 98632 to end. Msg&Data Rates May
				Apply. By opting in, I authorize Embrace Pet Insurance to deliver SMS messages
				using an automatic telephone dialing system and I understand that I am not required
				to opt in as a condition of purchasing any property, goods, or services. By leaving
				this box unchecked you will not be opted in for SMS messages at this time. Click to
				read <a
				qeBaseLink
				target="blank"
				[href]="smsTermsAndConditionsUrl"
				class="footer__links-item n--minimal"
				data-quat="action_smsTermsAndConditionsLink"
			>Terms & Conditions</a> & <a
				qeBaseLink
				size="small"
				[href]="privacyPolicyUrl"
				target="_blank"
				class="n--minimal"
				data-quat="action_smsPrivacyPolicyLink"
			>
				Privacy Policy
			</a>.
			</epi-hint>
		</div>
	</div>
	<div class="u-row u-margin-bottom-medium">
		<div
			class="u-row__column toggle-wrapper toggle-wrapper__military"
			role="presentation"
		>
		<epi-label>Are you active or former military?</epi-label>
			<epi-option-toggle
				qeCustomInput
				formControlName="military"
				id="pet-informaton-military"
				size="medium"
				layout="dense"
				data-quat="input_pet-sex"
			>
				<epi-toggle-choice
					#militaryYes
					value="yes"
					[selected]="militaryService"
					popular="false"
					slot="option"
					data-quat="input_militaryYes"
					(epi-toggle_selectionChange)="onRadioChange('military', 'yes')"
				>
					Yes
				</epi-toggle-choice>
				<epi-toggle-choice
					#militaryNo
					value="no"
					[selected]="!militaryService"
					popular="false"
					slot="option"
					data-quat="input_militaryNo"
					(epi-toggle_selectionChange)="onRadioChange('military', 'no')"
				>
				No
				</epi-toggle-choice>
			</epi-option-toggle>
		</div>
		<div
			class="u-row__column"
			role="presentation"
		>
		<div class="discount-banner">
			<img src="../../../assets/icons/discount.svg" class="discount-banner__icon"/>
			<div class="discount-banner__text">
				Get a 5% discount!
			</div>
		</div>
		</div>
	</div>
	<div
		*ngIf="!showEmployerForm && !showAgentForm"
		class="u-row u-margin-top-small"
		role="presentation"
	>
		<div
			class="u-row__column"
			role="presentation"
		>
			<ng-container *ngTemplateOutlet="submitButton"></ng-container>
		</div>
	</div>
</form>
</ng-template>
